import * as firebase from 'firebase';
import {Injectable} from '@angular/core';
import Analytics = firebase.analytics.Analytics;

@Injectable()
export class AnalyticsService {
  private _analytics: Analytics;
  private get analytics(): Analytics {
    if (!this._analytics) {
      this._analytics = firebase.analytics();
    }
    return this._analytics;
  }

  constructor() {
  }

  pageView(){
    this.analytics.logEvent('page_view',{
      page_title: 'Main'
    });
  }

  action(id:string, payload?:{[key:string]:any}) {
    if(payload) {
      this.analytics.logEvent('action-' + id, payload);
    }else{
      this.analytics.logEvent('action-' + id);
    }
  }
}
